// extracted by css-extract-rspack-plugin
export default {"overlay":"OpenInMenuV2-module__overlay__mUPRc","dropdownIcon":"OpenInMenuV2-module__dropdownIcon__ytsd7","cliDescription":"OpenInMenuV2-module__cliDescription__kfzMa"};